module.exports = __webpack_public_path__ + "img/google_play_.087e45f1.svg";